const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Reduce Energy Bills',
    description: 'Australian households save an average of $1,200–$2,000 per year after installing solar. Businesses often save significantly more, with some commercial operations cutting electricity costs by over 50%.',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-sun-line',
    title: 'World-Class Solar Resource',
    description: 'Australia receives some of the highest solar radiation on earth — averaging 4–6 peak sun hours per day across most of the country. This means Australian solar systems outperform equivalent systems in Europe and North America.',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-home-line',
    title: 'Increase Property Value',
    description: 'Research shows solar panels increase Australian property values by an average of $6,000–$29,000 depending on system size and location. Buyers increasingly expect solar as a standard feature.',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Energy Independence',
    description: 'Solar with battery storage gives your home or business the ability to generate, store, and use your own energy — reducing reliance on the grid and protecting against rising electricity prices.',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Clean, Renewable Energy',
    description: 'A typical 6.6kW solar system offsets approximately 9 tonnes of CO₂ per year — the equivalent of planting 400 trees. Solar is one of the most impactful individual actions Australians can take for the climate.',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-government-line',
    title: 'Government Incentives',
    description: 'Federal and state governments actively support solar adoption. Small-scale Technology Certificates (STCs) reduce upfront costs by $400–$600 per kW, while state programs add rebates and interest-free loans.',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
];

export default function SolarBenefits() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 mb-5">
            <i className="ri-sun-line text-primary-500 text-sm"></i>
            <span className="text-xs font-semibold text-primary-700 tracking-wide uppercase whitespace-nowrap">Why Solar in Australia</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Why Solar Energy is Right<br className="hidden md:block" /> for Australia
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Australia's climate, government policy, and energy market make it one of the best places in the world to invest in solar energy solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {benefits.map((benefit) => (
            <article
              key={benefit.title}
              className="bg-background-100/70 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 rounded-xl ${benefit.bg} flex items-center justify-center mb-5 group-hover:scale-105 transition-transform duration-300`}>
                <i className={`${benefit.icon} text-xl ${benefit.color}`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}